export function appointmentAction(appointment) {
    if (!appointment) return null;
    const status = String(appointment.status || "").trim().toLowerCase();
    const payment = String(appointment.payment_status || "").trim().toLowerCase();
    if (status === "cancelled") return null;
    if (payment === "completed") return "follow-up";
    if (status === "confirmed" && (
        payment === "deposit_paid" ||
        (payment === "unpaid" && appointment.deposit_required_cents === 0 && appointment.deposit_paid_cents === 0)
    )) return "complete";
    return "confirm";
}

export function confirmationLabel(appointment) {
    return Number.isSafeInteger(appointment?.deposit_required_cents) && appointment.deposit_required_cents > 0
        ? "Collect deposit"
        : "Confirm Appointment";
}
